import TNTReactAppComponent from "./tnt_react_app.component";

let TNTReactAppModule = angular
  .module("tntReactApp", [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/tntReactApp");

    $stateProvider.state("tntReactApp", {
      url: "/v2/index.html#/dashboard",
      component: "tntReactApp",
      data: {
        requireLogin: true,
        requireACL: "tnt_react_app.all",
      },
    });
  })
  .component("tntReactApp", TNTReactAppComponent).name;

export default TNTReactAppModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_react_app/index.js